import { render, staticRenderFns } from "./returnComfirmDialog.vue?vue&type=template&id=37b04a2a&scoped=true"
import script from "./returnComfirmDialog.vue?vue&type=script&lang=js"
export * from "./returnComfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b04a2a",
  null
  
)

export default component.exports